import { render, staticRenderFns } from "./NavPrimary.vue?vue&type=template&id=0812f114"
import script from "./NavPrimary.vue?vue&type=script&lang=js"
export * from "./NavPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports